/**
 * Pinia store configuration
 */
import { createPinia } from 'pinia'

const pinia = createPinia()

export default pinia

// Re-export stores for convenience
export { useAuthStore } from './auth.js'
export { useAppStore } from './app.js'
export { useCatalogStore } from './catalog.js'
export { usePromotionsStore } from './promotions.js'
export { useCartStore } from './cart.js'
export { useAssortmentRequestStore } from './assortmentRequest.js'
